import api from '@/api.js'

const state = {
    posusers: [],
    webposusers: [],
    terminals: [],
    filials: [],
    lss: [],
    bins: [],
    users: [],
    merchants: [],
    merchantCards: [],
    postags: [],
    webpostags: [],
    pkpassDirs: [],
    ekkframes: []
}

const getters = {
    pkpassDirs: state => {
        return state.pkpassDirs;
    },
    users: state => {
        return state.users;
    },
    isUsers: state => {
        return state.users.length;
    },
    user: state => {
        return (id) => {
            const o = state.users.find(e => {
                return e.idx == id
            });
            return o ? o : {};
        }
    },
    merchants: state => {
        return state.merchants;
    },
    isMerchants: state => {
        return state.merchants.length;
    },
    merchant: state => {
        return (id) => {
            const o = state.merchants.find(e => {
                return e.idx == id
            });
            return o ? o : {};
        }
    },
    merchantCards: state => {
        return state.merchantCards;
    },
    isMerchantCards: state => {
        return state.merchantCards.length;
    },
    merchantCard: state => {
        return (id) => {
            const o = state.merchantCards.find(e => {
                return e.idx == id
            });
            return o ? o : {};
        }
    },
    posusers: state => {
        return state.posusers;
    },
    postags: state => {
        return state.postags;
    },
    isPosUsers: state => {
        return state.posusers.length;
    },
    posuser: state => {
        return (id) => {
            const o = state.posusers.find(e => {
                return e.idx == id
            });
            return o ? o : {};
        }
    },
    webposusers: state => {
        return state.webposusers;
    },
    webpostags: state => {
        return state.webpostags;
    },
    isWebPosUsers: state => {
        return state.webposusers.length;
    },
    webposuser: state => {
        return (id) => {
            const o = state.webposusers.find(e => {
                return e.idx == id
            });
            return o ? o : {};
        }
    },
    filials: state => {
        return state.filials;
    },
    filial: state => {
        return (id) => {
            const o = state.filials.find(e => {
                return e.idx == id
            });
            return o ? o : {};
        }
    },
    isFilials: state => {
        return state.filials.length;
    },
    bins: state => {
        return state.bins;
    },
    bin: state => {
        return (id) => {
            const o = state.bins.find(e => {
                return e.bin == id
            });
            return o ? o : {};
        }
    },
    isBins: state => {
        return state.bins.length;
    },
    terminals: state => {
        return state.terminals;
    },
    terminal: state => {
        return (id) => {
            const o = state.terminals.find(e => {
                return e.idx == id
            });
            return o ? o : {};
        }
    },
    isTerminals: state => {
        return state.terminals.length;
    },
    lsservers: state => {
        return state.lss;
    },
    lss: state => {
        return (id) => {
            const o = state.lss.find(e => {
                return e.idx == id
            });
            return o ? o : {};
        }
    },
    isLss: state => {
        return state.lss.length;
    },
    isEkkframes: state => {
        return state.ekkframes.length;
    },

    ekkframes: state => {
        return (domen) => {
            try {
                const dom = domen.toLowerCase();
                const ret = state.ekkframes.filter(e => {
                    return e.domen.toLowerCase() == dom
                });
                return ret ? ret : [];
            } catch (error) {
                return [];
            }
        }
    }
}
const actions = {
    // POS_USERS    
    LOAD_POSUSERS: function (context) {
        api.getPosUsers().then(response => {
            context.commit("setPosUsers", response);
        });
    },
    INSERT_POSUSER: function (context, payload) {
        api.insertPosUser(payload).then(response => {
            if (response) context.commit("insertPosUser", {
                ...payload,
                idx: response
            })
        })
    },
    UPDATE_POSUSER: function (context, payload) {
        api.updatePosUser(payload.item).then(response => {
            if (response) context.commit("updatePosUser", payload)
        })
    },
    CLEAR_DEVICE: function (context, payload) {
        api.clearDevicePosUser(payload).then(response => {
            if (response) context.commit("clearDevicePosUser", payload)
        })
    },
    DELETE_POSUSER: function (context, payload) {
        api.deletePosUser(payload.idx).then(response => {
            if (response) context.commit("deletePosUser", payload)
        })
    },
    // WEB_POS_USERS    
    LOAD_WEBPOSUSERS: function (context) {
        api.getWebPosUsers().then(response => {
            context.commit("setWebPosUsers", response);
        });
    },
    INSERT_WEBPOSUSER: function (context, payload) {
        api.insertWebPosUser(payload).then(response => {
            if (response) context.commit("insertWebPosUser", {
                ...payload,
                idx: response
            })
        })
    },
    UPDATE_WEBPOSUSER: function (context, payload) {
        api.updateWebPosUser(payload.item).then(response => {
            if (response) context.commit("updateWebPosUser", payload)
        })
    },
    DELETE_WEBPOSUSER: function (context, payload) {
        api.deleteWebPosUser(payload.idx).then(response => {
            if (response) context.commit("deleteWebPosUser", payload)
        })
    },
    // TERMINALS    
    LOAD_TERMINALS: function (context) {
        api.getTerminals().then(response => {
            context.commit("setTerminals", response);
        });
    },
    INSERT_TERMINAL: function (context, payload) {
        api.insertTerminal(payload).then(response => {
            if (response) context.commit("insertTerminal", {
                ...payload.item,
                idx: response
            })
        })
    },
    UPDATE_TERMINAL: function (context, payload) {
        api.updateTerminal(payload).then(response => {
            if (response) context.commit("updateTerminal", payload)
        })
    },
    DELETE_TERMINAL: function (context, payload) {
        api.deleteTerminal(payload.idx).then(response => {
            if (response) context.commit("deleteTerminal", payload)
        })
    },
    // FILIALS    
    LOAD_FILIALS: function (context) {
        api.getFilials().then(response => {
            context.commit("setFilials", response);
        });
    },
    INSERT_FILIAL: function (context, payload) {
        api.insertFilial(payload).then(response => {
            if (response) context.commit("insertFilial", {
                ...payload,
                idx: response
            })
        })
    },
    UPDATE_FILIAL: function (context, payload) {
        api.updateFilial(payload.item).then(response => {
            if (response) context.commit("updateFilial", payload)
        })
    },
    DELETE_FILIAL: function (context, payload) {
        api.deleteFilial(payload.idx).then(response => {
            if (response) context.commit("deleteFilial", payload)
        })
    },
    // MERCHANTS    
    LOAD_MERCHANTS: function (context) {
        api.getMerchants().then(response => {
            context.commit("setMerchants", response);
        });
    },
    INSERT_MERCHANT: function (context, payload) {
        api.insertMerchant(payload).then(response => {
            if (response) context.commit("insertMerchant", {
                ...payload,
                idx: response
            })
        })
    },
    UPDATE_MERCHANT: function (context, payload) {
        api.updateMerchant(payload.item).then(response => {
            if (response) context.commit("updateMerchant", payload)
        })
    },
    DELETE_MERCHANT: function (context, payload) {
        api.deleteMerchant(payload.idx).then(response => {
            if (response) context.commit("deleteMerchant", payload)
        })
    },
    // MERCHANTCARDS    
    LOAD_MERCHANTCARDS: function (context) {
        api.getMerchantCards().then(response => {
            context.commit("setMerchantCards", response);
        });
    },
    INSERT_MERCHANTCARD: function (context, payload) {
        api.insertMerchantCard(payload).then(response => {
            if (response) context.commit("insertMerchantCard", {
                ...payload,
                idx: response
            })
        })
    },
    UPDATE_MERCHANTCARD: function (context, payload) {
        api.updateMerchantCard(payload.item).then(response => {
            if (response) context.commit("updateMerchantCard", payload)
        })
    },
    FREE_MERCHANTCARD: function (context, payload) {
        api.freeMerchantCard(payload.item.idx).then(response => {
            if (response) {
                payload.item.fingerprint = null;
                payload.item.datainfo = null;
                context.commit("updateMerchantCard", payload)
            }
        })
    },
    DELETE_MERCHANTCARD: function (context, payload) {
        api.deleteMerchantCard(payload.idx).then(response => {
            if (response) context.commit("deleteMerchantCard", payload)
        })
    },
    // BINS    
    LOAD_BINS: function (context) {
        api.getBins().then(response => {
            context.commit("setBins", response);
        });
    },
    INSERT_BIN: function (context, payload) {
        api.insertBin(payload).then(response => {
            if (response) context.commit("insertBin", {
                ...payload
            })
        })
    },
    UPDATE_BIN: function (context, payload) {
        api.updateBin(payload.item).then(response => {
            if (response) context.commit("updateBin", payload)
        })
    },
    DELETE_BIN: function (context, payload) {
        api.deleteBin(payload.bin).then(response => {
            if (response) context.commit("deleteBin", payload)
        })
    },
    // LSSERVERS    
    LOAD_LSS: function (context) {
        api.getLss().then(response => {
            context.commit("setLss", response);
        });
    },
    INSERT_LSS: function (context, payload) {
        api.insertLss(payload).then(response => {
            if (response) context.commit("insertLss", {
                ...payload.item,
                idx: response
            })
        })
    },
    UPDATE_LSS: function (context, payload) {
        api.updateLss(payload).then(response => {
            if (response) context.commit("updateLss", payload)
        })
    },
    DELETE_LSS: function (context, payload) {
        api.deleteLss(payload.idx).then(response => {
            if (response) context.commit("deleteLss", payload)
        })
    },
    // USERS    
    LOAD_USERS: function (context) {
        api.getUsers().then(response => {
            context.commit("setUsers", response);
        });
    },
    UPDATE_USER: function (context, payload) {
        api.updateUser(payload.item).then(response => {
            if (response) context.commit("updateUser", payload);
        });
    },
    INSERT_USER: function (context, payload) {
        api.insertUser(payload).then(response => {
            if (response) context.commit("insertUser", {
                ...payload,
                idx: response
            });
        });
    },
    DELETE_USER: function (context, payload) {
        api.deleteUser(payload.idx).then(response => {
            if (response) context.commit("deleteUser", payload);
        });
    },
    // PKPASS FUNCTIONS
    LOAD_PKPASS_DIRS: (context) => {
        api.loadPkpassDirs().then(response => {
            context.commit("setPkpassDirs", response);
        });
    },
    // EKK FRAMES
    LOAD_EKKFRAMES: (context) => {
        api.loadEkkFrames().then(response => {
            context.commit("setEkkFrames", response);
        });
    },

}
const mutations = {
    // PKPASS FUNCTIONS
    setPkpassDirs: (state, payload) => {
        state.pkpassDirs = payload;
    },
    //POSUSERS
    setPosUsers: (state, payload) => {
        state.posusers = payload;
        if (state.posusers) {
            state.posusers.filter(e => e.tags).forEach(e => {
                e.tags.forEach(t => {
                    if (state.postags.indexOf(t) == -1) state.postags.push(t.trim());
                })
            });
        }
    },
    insertPosUser: (state, payload) => {
        state.posusers.push({
            ...payload
        });
    },
    updatePosUser: (state, payload) => {
        Object.assign(state.posusers[payload.index], payload.item);
    },
    clearDevicePosUser: (state, payload) => {
        payload.item.deviceid = null;
        Object.assign(state.posusers[payload.index], payload.item);
    },
    deletePosUser: (state, payload) => {
        const index = state.posusers.findIndex(e => e.idx == payload.idx);
        if (index == -1) return;
        state.posusers.splice(index, 1)
    },
    //WEBPOSUSERS
    setWebPosUsers: (state, payload) => {
        state.webposusers = payload;
        if (state.webposusers) {
            state.webposusers.filter(e => e.tags).forEach(e => {
                e.tags.forEach(t => {
                    if (state.webpostags.indexOf(t) == -1) state.webpostags.push(t.trim());
                })
            });
        }
    },
    insertWebPosUser: (state, payload) => {
        state.webposusers.push({
            ...payload
        });
    },
    updateWebPosUser: (state, payload) => {
        Object.assign(state.webposusers[payload.index], payload.item);
    },
    deleteWebPosUser: (state, payload) => {
        const index = state.webposusers.findIndex(e => e.idx == payload.idx);
        if (index == -1) return;
        state.webposusers.splice(index, 1)
    },
    //TERMINALS
    setTerminals: (state, payload) => {
        state.terminals = payload;
    },
    insertTerminal: (state, payload) => {
        state.terminals.push({
            ...payload
        });
    },
    updateTerminal: (state, payload) => {
        Object.assign(state.terminals[payload.index], payload.item);
    },
    deleteTerminal: (state, payload) => {
        const index = state.terminals.findIndex(e => e.idx == payload.idx);
        if (index == -1) return;
        state.terminals.splice(index, 1)
    },
    //FILIALS
    setFilials: (state, payload) => {
        state.filials = payload;
    },
    insertFilial: (state, payload) => {
        state.filials.push({
            ...payload
        });
    },
    updateFilial: (state, payload) => {
        Object.assign(state.filials[payload.index], payload.item);
    },
    deleteFilial: (state, payload) => {
        const index = state.filials.findIndex(e => e.idx == payload.idx);
        if (index == -1) return;
        state.filials.splice(index, 1)
    },
    //MERCHANTS
    setMerchants: (state, payload) => {
        state.merchants = payload;
    },
    insertMerchant: (state, payload) => {
        state.merchants.push({
            ...payload
        });
    },
    updateMerchant: (state, payload) => {
        Object.assign(state.merchants[payload.index], payload.item);
    },
    deleteMerchant: (state, payload) => {
        const index = state.merchants.findIndex(e => e.idx == payload.idx);
        if (index == -1) return;
        state.merchants.splice(index, 1)
    },
    //MERCHANTCARDS
    setMerchantCards: (state, payload) => {
        state.merchantCards = payload;
    },
    insertMerchantCard: (state, payload) => {
        state.merchantCards.push({
            ...payload
        });
    },
    updateMerchantCard: (state, payload) => {
        Object.assign(state.merchantCards[payload.index], payload.item);
    },
    deleteMerchantCard: (state, payload) => {
        const index = state.merchantCards.findIndex(e => e.idx == payload.idx);
        if (index == -1) return;
        state.merchantCards.splice(index, 1);
    },
    //BINS
    setBins: (state, payload) => {
        state.bins = payload;
    },
    insertBin: (state, payload) => {
        state.bins.push({
            ...payload
        });
    },
    updateBin: (state, payload) => {
        Object.assign(state.bins[payload.index], payload.item);
    },
    deleteBin: (state, payload) => {
        const index = state.bins.findIndex(e => e.bin == payload.bin);
        if (index == -1) return;
        state.bins.splice(index, 1)
    },
    //LSS
    setLss: (state, payload) => {
        state.lss = payload;
    },
    insertLss: (state, payload) => {
        state.lss.push({
            ...payload
        });
    },
    updateLss: (state, payload) => {
        Object.assign(state.lss[payload.index], payload.item);
    },
    deleteLss: (state, payload) => {
        const index = state.lss.findIndex(e => e.idx == payload.idx);
        if (index == -1) return;
        state.lss.splice(index, 1)
    },
    // USERS
    setUsers: (state, payload) => {
        state.users = payload;
    },
    updateUser: (state, payload) => {
        Object.assign(state.users[payload.index], payload.item);
    },
    insertUser: (state, payload) => {
        state.users.push({
            ...payload
        });
    },
    deleteUser: (state, payload) => {
        const index = state.users.findIndex(e => e.idx == payload.idx);
        if (index == -1) return;
        state.users.splice(index, 1)
    },
    setEkkFrames: (state, payload) => {
        state.ekkframes = payload;
    },
}

const Data = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}

export default Data;